import React from 'react';
import injectSheet from 'react-jss';
import { graphql, withApollo } from 'react-apollo';

// import { MOA_COLOR } from 'shared/constants/colors';

// References:
// Email regex from: http://emailregex.com/
// Converted into json from: http://bernhardhaeussner.de/odd/json-escape/
import jsonSchema from 'shared/json_schemas/userSignupForm';
import { compose, extractFirstErrorMessage, isEmptyArray } from 'shared/helpers';
import {
  gqlSubmitSignupForm,
  gqlValidateUsernameForSignup,
  gqlValidateEmailForSignup,
} from 'shared/gql/auth';

import { mixClasses as cx } from 'helpers/styleHelper';
import manageUserAuthForm, { gqlSubmitFormCfg } from './manageUserAuthForm';

import Formation from 'components/utils/Formation';
import Input from 'components/elems/Input';
import { FontIcon, DoubleBouncer, RectButton, Link } from 'components/elems';
import { alert } from 'presets';



// http://stackoverflow.com/questions/39814853/apollo-graphql-react-how-to-query-on-click
const withApolloFuncFactory = (callableName, payloadKey, opts = {}) => {
  const func = (client, variables = {}) => {
    const _opts = {...opts, variables};
    return client[callableName](_opts);
  };

  // HACK: We need to know which key in data response to lookup and
  // not easy to extract this from the gql document node
  func.payloadKey = payloadKey;
  return func;
};

// TODO: refactor to just read from query name
// NOTE: Must return `errors` in data response.
const validators = {
  // Potentially any one-off validation logic..
  // validateLocallyFuncMap: {},
  validateWithApolloClientFuncMap: {
    username: withApolloFuncFactory('query', 'signupInputLivecheck', {
      query: gqlValidateUsernameForSignup,
    }),
    email: withApolloFuncFactory('query', 'signupInputLivecheck', {
      query: gqlValidateEmailForSignup,
    }),
  },
};

const WordyCopyAboveSignupForm = () => (
  <div className="moa-ff-sans mt2 black-70">
    <div className="f3 mb2 fw6">
      Here is the thing.
    </div>
    <div className="mv4 pb2 lh-copy">
      <p>
        Blogs, tweets, snaps, grams, boards..  whatever.
      </p>
      <p>
        Everything you create should orbit around you,
        not the other way around.
      </p>
      <p>
        You can change that now — <span>with</span>&nbsp;
        <span style={{fontWeight: 600}}>Moagraph</span>.
      </p>
    </div>
  </div>
);



let SignupSubmitSuccessFeedback = ({
  classes: cn,
  metadata = {},
}) => {
  // `user_signup` field -> `validation` response should have
  // `email_confirm_token` under `metadata`
  const { email_confirm_token: token } = metadata;
  // TODO: Derive the root path from somewhere central.
  const resendLinkTo = `/a/resend/confirm-signup-email?token=${token}`;
  const resendLink = (
    <Link type="accented" to={resendLinkTo} target="_blank">
      request to resend
    </Link>
  );

  return (
    <div className="moa-ff-sans black-70">
      <div className={cx(cn.heading, 'f1 mb4 fw7')}>
        Thanks!
      </div>
      <div className={cx(cn.bodyCon, 'mt5 lh-copy')}>
        <div className="fw6">
          Please check your inbox.
        </div>
        <div className="mt3">
          You've just been sent an email to confirm your
          email address. Please click on the link in
          the email to confirm your signup.
        </div>
        <div className={cx('mt5 f6')}>
          ***
        </div>
        <div className="mt1 f6">
          Don't see an email from us?
          Please be sure to check your spam folder first.
          You can also {resendLink}.
        </div>
      </div>
    </div>
  );
};
SignupSubmitSuccessFeedback = injectSheet({
  heading: {
    opacity: 0,
    animation: `opacityFadeInFull 500ms ease-in-out 1 forwards,
                translatePositionUp 350ms ease-in-out forwards`
  },
  bodyCon: {
    opacity: 0,
    animation: `opacityFadeInFull 500ms ease-in-out 400ms 1 forwards,
                translatePositionUp 350ms ease-in-out 400ms 1 forwards`
  },
})(SignupSubmitSuccessFeedback);



const UserSignupForm = (props) => {
  // GraphQL type as key.
  const { userSignup = {} } = props.respData;

  // We have successfully submitted without errors.
  if (isEmptyArray(userSignup.errors)) {
    const metadata = JSON.parse(userSignup.metadata);
    return <SignupSubmitSuccessFeedback metadata={metadata} />;
  }

  const errorMessage = extractFirstErrorMessage(userSignup.errors);
  const alertDisplay = errorMessage ? alert.error(errorMessage) : null;

  const btnIcon = (props.isSubmitting ?
    <DoubleBouncer /> :
    <FontIcon type="arrowright" style={{fontSize: '.875rem'}} />
  );

  const {
    copyAboveSignupForm = <WordyCopyAboveSignupForm/>,
    stuffBelowSignupForm = null,
  } = props;

  return (
    <div>
      {copyAboveSignupForm}

      <div className={cx('mt4')}>
        <Formation
          formData={props.formData}
          onFocus={props.handleInputOnFocus}
          onChange={props.handleInputOnChange}
          onBlur={props.handleInputOnBlur}
        >
          <Input
            name="username"
            helperText="Must be between 2 and 16 alphanumeric characters. One underscore or period is allowed after the first character."
          />
          <Input name="email" />
          <Input
            name="password"
            type="password"
            helperText="Must be at least 8 characters without spaces"
          />
          <Input name="invite_code" />
        </Formation>

        {alertDisplay &&
          <div className="mt4">
            {alertDisplay}
          </div>
        }

        <div className={cx('mt4 flex justify-end')}>
          <RectButton
            label="START"
            icon={btnIcon}
            isEnabled={props.validateFormData()}
            isActivated={props.isSubmitting}
            onClick={props.submitForm}
          />
        </div>
      </div>

      {stuffBelowSignupForm}
    </div>
  );
};

// ^(?:[a-zA-Z0-9]|[._]?){2,20}$

            // helperText="Must be between 2 to 16 characters, and contain only letters or numbers"

export default compose(
  withApollo,
  graphql(gqlSubmitSignupForm, gqlSubmitFormCfg),
  manageUserAuthForm(jsonSchema, validators),
)(UserSignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/UserSignupForm.js